import {types, flow} from 'mobx-state-tree';
import axios from 'axios';
import {CUSTOMERS_API} from '@constants/api';
import {AlertResultApi} from '@utils/alert';
import {fetching, FetchingEnum} from './Fetching';

export const initialStateCustomers = {
  fetching: FetchingEnum.DONE,
};

const CustomerData = types.model({
  id: types.identifierNumber,
  firstName: types.string,
  lastName: types.string,
  mobile: types.string,
  status: types.string,
  balance: types.number,
});

export const Customers = types
  .model('Customer', {
    data: types.maybeNull(CustomerData),
    fetching: fetching,
    status: types.maybeNull(types.number),
  })
  .actions(self => ({
    getOutstandingPrice: flow(function* getOutstandingInvoice(
      token: string,
      accountingCustomerId: number,
    ) {
      self.fetching = 'pending';
      self.data = null;
      self.status = null;
      try {
        const result = yield axios.get(
          `${CUSTOMERS_API}/${accountingCustomerId}`,
          {
            headers: {Authorization: `Bearer ${token}`},
          },
        );
        self.status = result.status;
        self.data = result.data;
        self.fetching = 'done';
      } catch (error: any) {
        // console.error('Failed to fetch projects', error);
        self.fetching = 'error';
        self.status = error?.response?.status || 500;
        AlertResultApi(
          error?.response?.status || 500,
          error.response?.data?.message,
        );
      }
    }),
  }));
